export default class Project {
  constructor(project) {
    this.initializeData();
    this.extraDataFetched = false;
    this.setData(project);
  }

  initializeData() {
    const defaultValue = {
      // GENERIC RELATED DATA
      uuid: null,
      projectId: null,
      alerts: [],
      createdByOldRapso: false,
      isArchived: false,
      questionnairesCompleted: {},
      questionnaireFetchedAt: null,
      questionnaireRedirectionAllowed: true,
      isFavorite: false,
      isProjectInBim: false,
      originId: null,
      projectCity: "",
      projectManager: null,
      projectName: "",
      phase: "",
      spsCategory: "",
      spsPhase: "",
      createdAt: null,
      updatedAt: null,
      atlasMethodo: "",
      chronorapso: null,
      sectionsUpdatedAt: null,
      isDuplicatedFroms: [],
      entity: null,
      reportsSurvey: {},

      //batches
      batches: [],

      // CASE RELATED DATA
      cloud: null,
      contractingAgency: null,
      subcontractingAgency: null,
      caseNumber: null,
      caseLabel: null,
      caseSituation: null,
      caseStatus: null,
      forcedStatus: null,
      clientCode: null,
      clientLabel: null,
      clientPostcode: null,
      clientAddress: null,
      clientCity: null,
      clientTelephone: null,
      clientMobile: null,
      clientEmail: null,
      contactCompany: null,
      contactLegalForm: null,
      contactFirstName: null,
      contactLastName: null,
      contactRole: null,
      contactPostcode: null,
      contactAddress: null,
      contactTelephone: null,
      contactMobile: null,
      contactEmail: null,
      contactCity: null,
      clientSiren: null,
      clientNic: null,
      clientUpdatedInRapsotec: null,
      decisionCenterCode: null,
      decisionCenterLabel: null,
      financialStakeholderFirstName: null,
      financialStakeholderLastName: null,
      initialAmount: null,
      finalAmount: null,
      opeStartDate: null,
      estimatedDuration: null,
      signDate: null,
      totalBeforeTax: null,
      facturationCalculMode: null,
      isCea: null,
      ceaRef: "",
      isDefenseSecret: null,
      invoiceDateLastDeadline: null,
      agencyCountry: "",
      casePostcode: "",
      isNationalContract: null,

      // CANVAS CONFIGURATION && MISSION TAB DATA
      missions: [],
      destinations: [],
      mainDestination: "",
      types: [],
      otherMissions: [],
      workDescription: "",
      isProjectRpp: null,
      missionInformation: "",
      missionLimits: "",
      additionalComments: "",

      // AFFAIRE TAB RELATED DATA
      rictPublicationDate: null,
      projectAddress: "",
      projectPostcode: "",
      buildingPermitRequestDate: null,
      buildingPermitNumberOfBp: null,
      buildingPermitAcquisitionDate: null,
      buildingPermitPossibleAmendments: null,
      permitType: "",
      dceDate: null,
      revisedWorksAmount: null,
      workAmountEvolutionRequestSent: false,
      deadlineType: null,
      dateWorkDeadline: null,
      showFieldsCharacteristics: null,
      buildingPermitCompetentAuthorityName: null,
      safetyRegisterConstitutionStatus: null,
      safetyRegisterRevisionDate: null,
      coverPhoto: null,

      // RVRAT RELATED DATA
      oldRvratData: "",
      pabMainActivity: "",
      oldPabMainActivity: "",
      pabCategory: null,
      numberOfBuildings: null,
      numberOfLevels: null,
      constructiveSpecificitiesThirdParty: null,
      constructiveSpecificitiesAtrium: null,
      constructiveSpecificitiesNotModifiedByWork: null,
      installationTechniquesSmoke: null,
      installationTechniquesHeatingMode: null,
      installationTechniquesGasOrHydrocarbons: null,
      installationTechniquesSecurityInstallation: null,
      installationTechniquesHTStation: null,
      installationTechniquesEmergencyLighting: null,
      installationTechniquesRestaurantEquipment: null,
      installationTechniquesLift: null,
      installationTechniquesExtinguishers: null,
      installationTechniquesSSI: null,
      installationTechniquesAlarm: null,
      staffings: [],
      clearances: [],
      roomClearances: [],
      justifications: [],
      measurements: [],
      safetyReviews: [],
      staffingComment: "",
      clearanceComment: "",
      roomClearanceComment: "",
      safetyCommissionPrescription: "",
      disabledEvacuationProcess: "",
      safetyCommissionDate: null,
      technicalChecksEndDate: null,

      // WEBMAIL RELATED DATA
      webmailLogin: "",
      webmailEmail: "",
      webmailPrimaryId: "",
      webmailPassword: "",
      unreadMailNumber: 0,

      // TIMELINE RELATED DATA
      feesData: null,
      contractualScope: null,
      projectWorkStartDate: null,
      projectRealDuration: null,

      // ITM RELATED DATA
      nonVerifiedPartsNotRealised: "",
      nonVerifiedPartsOutOfMission: "",
      additionalPrescriptions: null,
      prescriptionDisposition: "",
      exemptionsGranted: null,
      exemptionDetails: "",
      lowVoltage: null, // LowVoltage
      fireDetection: null, // FireDetection
      riskyLocals: null, // RiskyLocals
      lightning: null,
    };

    for (let [key, value] of Object.entries(defaultValue)) {
      this[key] = value;
    }
  }

  setData(project) {
    // ----------------- SET PROJECT DATA HERE ----------
    for (let [key, value] of Object.entries(project)) {
      if (key in this) {
        this[key] = value;
      }
    }

    // computed data
    this.worksProgress = this.getWorksProgress();
  }
  getWorksProgress() {
    const startDate = this.projectWorkStartDate || this.opeStartDate;
    if (!startDate || !this.estimatedDuration) {
      return 0;
    }

    const formattedStartDate = new Date(startDate);
    const dateNow = new Date();

    const completedMonth = (dateNow - formattedStartDate) / (1000 * 60 * 60 * 24 * 30.5);

    if (completedMonth < 0) return 0;
    if (completedMonth > this.estimatedDuration) return 100;

    return Math.round((completedMonth / this.estimatedDuration) * 100);
  }

  getSaleAmountDetails(caseOrProjectKey, totalOrInvoiced) {
    // A.C 04/08/26 feesData peut être null (atlas injoignable ou projet inconnu d'atlas) : il
    // faut garder chaque niveau, un test de vérité sur feesData seul laisse passer un objet
    // partiel et le déréférencement casse plus bas (cf. RTEC-3326).
    const fees = this.feesData?.[caseOrProjectKey];
    if (!fees) {
      return "";
    }
    if (!totalOrInvoiced) {
      if (!fees.invoicedFee || !fees.saleAmount) {
        return "";
      }
      return `
        AXXX: ${fees.invoicedFee.salesA} / ${fees.saleAmount.salesA}
        HCDA: ${fees.invoicedFee.salesHCDA} / ${fees.saleAmount.salesHCDA}
        HBAG: ${fees.invoicedFee.salesHBAG} / ${fees.saleAmount.salesHBAG}
        HBAA: ${fees.invoicedFee.salesHBAA} / ${fees.saleAmount.salesHBAA}
        ---> total ct: ${fees.invoicedFee.salesCt} / ${fees.saleAmount.salesCt}
        other: ${fees.invoicedFee.salesOther} / ${fees.saleAmount.salesOther}
        ---> total all: ${fees.invoicedFee.salesTotal} /  ${fees.saleAmount.salesTotal}

        Legend: Atlas code: Montant facturé / Montant prévue`;
    }
    if (!fees[totalOrInvoiced]) {
      return "";
    }
    return `AXXX: ${fees[totalOrInvoiced].salesA}
      HCDA: ${fees[totalOrInvoiced].salesHCDA}
      HBAG: ${fees[totalOrInvoiced].salesHBAG}
      HBAA: ${fees[totalOrInvoiced].salesHBAA}
      ---> total ct: ${fees[totalOrInvoiced].salesCt}
      other: ${fees[totalOrInvoiced].salesOther}
      ---> total all: ${fees[totalOrInvoiced].salesTotal}

      Legend: Atlas code: Montant`;
  }
}
